// extracted by mini-css-extract-plugin
module.exports = {"item":"SideListItem_item__esZeu","title":"SideListItem_title__R6gsR","image":"SideListItem_image__2yyqx","img":"SideListItem_img__2pYew"};